export default {
  transparent: 'transparent',
  white: '#fff',
  black: '#000',
  primary: '#0082CA',
  secondary: '#00B2E3',
  neutral: '#F5F5F5',
  neutralDark: '#707070',
  dark: '#000000DE',
  dark2: '#303030',
  backgroundLight: '#F4F9FC',
  background: '#EDF9FC',
  error: '#B00020',
  success: '#80D684',
  warning: '#FFF836',
  warningDark: '#F8C44E',
  notification: '#FD3E64',
  blue: '#4A90E2',
  purple: '#9B51E0',
  optionSelected: '#E0E0E0',
  shiftNeuroBackground: '#D4D4FF',
  shiftTeleNeuroBackground: '#ffe3e3',
  shiftEegBackground: '#C7F09E',
  shiftPedoEegBackground: '#F0F09E',
  placeholder: 'rgba(0, 0, 0, 0.4)',
};
